import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { iconSize } from '../../../utils/helpers.js';

/* eslint-disable max-len */

var Employees = (function (_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'xs' : _a$size,
      props = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: iconSize[size],
    height: iconSize[size],
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4336 15.3387C22.4336 18.2468 20.0538 20.5773 17.0843 20.5773C14.1158 20.5773 11.7349 18.2468 11.7349 15.3387C11.7349 12.4305 14.1158 10.1 17.0843 10.1C20.0538 10.1 22.4336 12.4305 22.4336 15.3387ZM9 26.5091C9 23.817 12.7241 23.1435 17.0843 23.1435C21.4681 23.1435 25.1685 23.8402 25.1685 26.5344C25.1685 29.2264 21.4445 29.9 17.0843 29.9C12.7004 29.9 9 29.2033 9 26.5091ZM24.5907 15.4336C24.5907 16.9146 24.1365 18.2964 23.3401 19.4443C23.2572 19.5624 23.3304 19.7215 23.4746 19.7468C23.6748 19.7795 23.8804 19.7995 24.0903 19.8037C26.1783 19.8575 28.0522 18.541 28.5699 16.5583C29.3373 13.6164 27.0857 10.975 24.2173 10.975C23.9062 10.975 23.6081 11.0066 23.3175 11.0646C23.2776 11.073 23.2346 11.092 23.213 11.1257C23.1851 11.1689 23.2055 11.2248 23.2335 11.2617C24.0956 12.4454 24.5907 13.8863 24.5907 15.4336ZM28.049 21.8725C29.4525 22.1413 30.3749 22.6884 30.757 23.4863C31.081 24.1398 31.081 24.8987 30.757 25.5522C30.1726 26.7876 28.2869 27.185 27.5539 27.2872C27.4021 27.3083 27.2805 27.1818 27.2966 27.0321C27.6712 23.6086 24.693 21.9853 23.9224 21.6122C23.8901 21.5943 23.8825 21.569 23.8858 21.5521C23.8879 21.5416 23.9019 21.5247 23.9267 21.5215C25.5939 21.4899 27.387 21.7144 28.049 21.8725Z",
    fill: "currentColor"
  }));
});

export { Employees as default };
